<template>
  <page>
    <!-- Keep for further need or enhancement -->
    <!-- <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div> -->
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md4>
                        <v-text-field v-model="filters.cDisc_campaign" :label="labels.cDisc_campaign" :error-messages="errors.collect('cDisc_campaign')" data-vv-name="cDisc_campaign" :data-vv-as="labels.cDisc_campaign"></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <cal-picker :label="labels.cDisc_effDate" v-model="filters.cDisc_effDate" :error-messages="errors.collect('cDisc_effDate')" data-vv-name="cDisc_effDate" :data-vv-as="labels.cDisc_effDate"></cal-picker>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md4>
                        <v-text-field v-model="filters.cDisc_discLdg1" :label="labels.cDisc_discLdg1" :error-messages="errors.collect('cDisc_discLdg1')" data-vv-name="cDisc_discLdg1" :data-vv-as="labels.cDisc_discLdg1"></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field v-model="filters.cDisc_discLdg2" :label="labels.cDisc_discLdg2" :error-messages="errors.collect('cDisc_discLdg2')" data-vv-name="cDisc_discLdg2" :data-vv-as="labels.cDisc_discLdg2"></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field v-model="filters.cDisc_discLdg3" :label="labels.cDisc_discLdg3" :error-messages="errors.collect('cDisc_discLdg3')" data-vv-name="cDisc_discLdg3" :data-vv-as="labels.cDisc_discLdg3"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew()">
            New Campaign Discount
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.cDisc_campaign }}</td>
                <td>{{ formatDisplayDate(row.item.cDisc_effDate) }}</td>
                <td>{{ row.item.cDisc_discLdg1 }}</td>
                <td>{{ row.item.cDisc_discLdg2 }}</td>
                <td>{{ row.item.cDisc_discLdg3 }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)" query @query="doQuery(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Campaign Discount?
      </confirm>
    </div>
  </page>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'

// Keep for further need or enhancement
// import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Campaign Commission',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'campaignCommList' }
        },
        {
          text: 'Campaign Promotion',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'campaignPromotionList' }
        },
        {
          text: 'Permit Intermediary',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'campaignIntermediaryList' }
        },
        {
          text: 'Promotion',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'promotionList' }
        }
      ],
      toogleArray: [false],
      headers: [
        { text: 'Campaign', value: 'cDisc_campaign' },
        { text: 'Effective Date', value: 'cDisc_effDate' },
        { text: 'Discount / Loading (1)', value: 'cDisc_discLdg1' },
        { text: 'Discount / Loading (2)', value: 'cDisc_discLdg2' },
        { text: 'Discount / Loading (3)', value: 'cDisc_discLdg3' },
        TableConst.tableActionHeader
      ],
      labels: {
        cDisc_campaign: 'Campaign',
        cDisc_effDate: 'Effective Date',
        cDisc_discLdg1: 'Discount / Loading (1)',
        cDisc_discLdg2: 'Discount / Loading (2)',
        cDisc_discLdg3: 'Discount / Loading (3)'
      },
      filters: {
        cDisc_campaign: undefined,
        cDisc_effDate: undefined,
        cDisc_discLdg1: undefined,
        cDisc_discLdg2: undefined,
        cDisc_discLdg3: undefined,
        actionKey: undefined
      },
      totalItems: 0,
      selectedProp: undefined,
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.cDisc_effDate) {
            currFilters.cDisc_effDate = formatDisplayDateTime2(removeTime(currFilters.cDisc_effDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  cDisc_campaign: datamap.cDisc_campaign,
                  cDisc_effDate: datamap.cDisc_effDate,
                  cDisc_discLdg1: datamap.cDisc_discLdg1,
                  cDisc_discLdg1Pct: datamap.cDisc_discLdg1Pct,
                  cDisc_protectDiscLdg1: datamap.cDisc_protectDiscLdg1,
                  cDisc_applyDiscLdg1: datamap.cDisc_applyDiscLdg1,
                  cDisc_discLdg2: datamap.cDisc_discLdg2,
                  cDisc_discLdg2Pct: datamap.cDisc_discLdg2Pct,
                  cDisc_protectDiscLdg2: datamap.cDisc_protectDiscLdg2,
                  cDisc_applyDiscLdg2: datamap.cDisc_applyDiscLdg2,
                  cDisc_discLdg2GN: datamap.cDisc_discLdg2GN,
                  cDisc_discLdg3: datamap.cDisc_discLdg3,
                  cDisc_discLdg3Pct: datamap.cDisc_discLdg3Pct,
                  cDisc_protectDiscLdg3: datamap.cDisc_protectDiscLdg3,
                  cDisc_applyDiscLdg3: datamap.cDisc_applyDiscLdg3,
                  cDisc_discLdg3GN: datamap.cDisc_discLdg3GN,
                  actionKey: datamap.actionKey
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.cDisc_campaign = undefined
      this.filters.cDisc_effDate = undefined
      this.filters.cDisc_discLdg1 = undefined
      this.filters.cDisc_discLdg2 = undefined
      this.filters.cDisc_discLdg3 = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      this.$router.push({ name: 'campaignDiscReview', params: { paramMode: 'review', paramObjRes: obj } })
    },
    doNew() {
      this.$router.push({ name: 'campaignDiscReview', params: { paramMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'campaignDiscReview', params: { paramMode: 'query', paramObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.doDelete
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.campaignParam.menu
    }
  },
  mounted() {
    this.filters.actionKey = 'CAMPAIGN_DISCOUNT'
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    // Keep for further need or enhancement
    // SideFunctionMenu
  }
}
</script>
